module.exports = __webpack_public_path__ + "img/bg3.befadb09.webp";